import React from 'react';
import { Globe, Bell, Plus, ShieldAlert, LogOut } from 'lucide-react';

export default function Header({
  notificationCount = 0,
  onOpenNotifications,
  onAddDomain,
  onGenerateInvoice,
  onGenerateProforma,
  onLogout,
  activeFilter,
  onFilterChange,
  onnotesApp
}) {
  return (
    <header className="glass-panel header-container" style={{
      background: 'rgba(255, 255, 255, 0.9)',
      border: '1px solid rgba(255, 255, 255, 0.8)',
      borderRadius: '24px',
      boxShadow: '0 10px 30px -5px rgba(99, 102, 241, 0.12)'
    }}>

      {/* Brand Logo */}
      <div className="header-brand">

        <div>
          <h1 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            letterSpacing: '-0.5px',
            background: '#6366f1',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            Domain Mgmt
          </h1>
          <p style={{ fontSize: '0.8rem', color: '#64748b', fontWeight: '600' }}>
            Invoice Generator
          </p>
        </div>
      </div>

      {/* Actions */}
      <div className="header-actions">
        {/* Notification Bell Button */}
        <button
          className="btn btn-secondary"
          onClick={onOpenNotifications}
          style={{ position: 'relative', padding: '10px 18px', borderRadius: '14px' }}
          title="Renewal Notifications"
        >
          <Bell size={19} color={notificationCount > 0 ? '#ea580c' : '#64748b'} />
          <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#1e293b' }}>Alerts</span>

          {notificationCount > 0 && (
            <span style={{
              position: 'absolute',
              top: '-6px',
              right: '-6px',
              background: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: '800',
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.45)',
              border: '2px solid #ffffff'
            }}>
              {notificationCount}
            </span>
          )}
        </button>

        {/* Quick Filter: Expiring Soon Shortcut */}
        {notificationCount > 0 && (
          <button
            className={`btn ${activeFilter === 'needs_renewal' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => onFilterChange(activeFilter === 'needs_renewal' ? 'all' : 'needs_renewal')}
            style={{
              borderColor: activeFilter === 'needs_renewal' ? undefined : '#fdba74',
              color: activeFilter === 'needs_renewal' ? undefined : '#c2410c',
              background: activeFilter === 'needs_renewal' ? undefined : '#fff7ed',
              borderRadius: '14px'
            }}
          >
            <ShieldAlert size={17} />
            <span>Needs Renewal ({notificationCount})</span>
          </button>
        )}

        {/* Add Domain Button */}
        <button
          className="btn btn-primary"
          onClick={onAddDomain}
          style={{ borderRadius: '14px', padding: '11px 20px', marginRight: '8px' }}
        >
          <Plus size={20} />
          <span>Add Domain</span>
        </button>
        <button
          className="btn btn-secondary"
          onClick={onnotesApp}
          style={{ borderRadius: '14px', padding: '11px 20px', marginRight: '8px' }}
        >
          <Plus size={20} />
          <span>Notes</span>
        </button>
        <button
          className="btn btn-secondary"
          onClick={onGenerateInvoice}
          style={{ borderRadius: '14px', padding: '11px 20px', marginRight: '8px' }}
        >
          <Plus size={20} />
          <span>Invoice</span>
        </button>
        <button
          className="btn btn-secondary"
          onClick={onGenerateProforma}
          style={{ borderRadius: '14px', padding: '11px 20px' }}
        >
          <Plus size={20} />
          <span>Proforma</span>
        </button>
        <button
          className="btn btn-secondary"
          onClick={onLogout}
          style={{
            borderRadius: '14px',
            padding: '11px 18px',
            color: '#dc2626',
            borderColor: '#fecaca',
            background: '#fff1f2'
          }}
          title="Logout"
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}
